module.exports = __webpack_public_path__ + "static/media/blue-bckg.bc61a5df.jpeg";